export default "__VITE_ASSET__a3c8835c__"